const throttle = require('lodash/throttle');

const threshold = 0;
let intersected = false;
let isSticky = false;
let lastScrollTop = 0;

const CLASSES = {
  SCROLLING: 'header--scrolling',
  FIXED: 'header--fixed',
  STICKY: 'header--sticky',
};

// 0: no scroll; -1: scroll down; 1: scroll up
function getScrollState(next, current) {
  if (next - current < -threshold || next < threshold) {
    return -1;
  } else if (next - current > threshold) {
    return 1;
  }
  return 0;
}

function update(el) {
  const top = window.pageYOffset;
  const scrollState = getScrollState(lastScrollTop, top);

  if (document.querySelector('.js-menu')?.getAttribute('aria-expanded') === 'true') {
    return;
  }

  if (top > 0) {
    el.classList.add(CLASSES.SCROLLING);
  } else {
    el.classList.remove(CLASSES.SCROLLING, CLASSES.STICKY, CLASSES.FIXED);
    isSticky = false;
  }

  if (intersected) {
    if (scrollState === 1) {
      el.classList.add(CLASSES.STICKY);
      isSticky = true;
    } else if (scrollState === -1) {
      el.classList.remove(CLASSES.STICKY);
      isSticky = false;
    }
  }

  if (!intersected && !isSticky) {
    el.classList.remove(CLASSES.FIXED, CLASSES.STICKY);
  }

  lastScrollTop = top;
}

function init() {
  const el = document.querySelector('.header');
  if (el) {
    update(el);
    window.addEventListener(
      'scroll',
      throttle(() => update(el), 300)
    );

    const observer = new IntersectionObserver(([entry]) => {
      intersected = !intersected && !entry.isIntersecting;
      intersected ? el.classList.add(CLASSES.FIXED) : null;

      if (entry.isIntersecting) {
        el.classList.remove(CLASSES.FIXED, CLASSES.STICKY);
      }
    });
    observer.observe(el);

    window.requestAnimationFrame(() => el.classList.add('header--initialized'));
  }
}

export { init };
